module.exports = __webpack_public_path__ + "static/media/3-2.1ea54212.jpg";